import { CommonError } from '../../types';
import { FETCH_CHARTS_FAILURE, FETCH_CHARTS_REQUEST, FETCH_CHARTS_SUCCESS } from './constants';
import { ChartData } from './types';

export interface FetchChartRequestAction {
    type: typeof FETCH_CHARTS_REQUEST;
    payload: string;
}

export interface FetchChartSuccessAction {
    type: typeof FETCH_CHARTS_SUCCESS;
    payload: ChartData[];
}

export interface FetchChartFailureAction {
    type: typeof FETCH_CHARTS_FAILURE;
    payload: CommonError;
}

export type ChartActions = FetchChartRequestAction | FetchChartSuccessAction | FetchChartFailureAction;

export const  fetchChartRequest = (payload: string): FetchChartRequestAction => ({
    type: FETCH_CHARTS_REQUEST,
    payload
});

export const fetchChartSuccess = (chartDatas: ChartData[]): FetchChartSuccessAction => ({
    type: FETCH_CHARTS_SUCCESS,
    payload: chartDatas,
});

export const fetchChartFailure = (error: CommonError): FetchChartFailureAction => ({
    type: FETCH_CHARTS_FAILURE,
    payload: error,
});

